import { LS_KEY_REFRESH_TOKEN_EXP_DATE } from "../../../constants";

export function shouldSkipTokenRefresh(refreshTokenThrottleTimeout: number): boolean {
    const expDate = localStorage.getItem(LS_KEY_REFRESH_TOKEN_EXP_DATE);
    if (!expDate) return false;
    const refreshTokenExpiresInMilliseconds = new Date(expDate).getTime() - new Date().getTime();
    const result = refreshTokenExpiresInMilliseconds > refreshTokenThrottleTimeout;
    return result;
}
